export default __webpack_public_path__ + "static/media/card_info_bg.d04f6c6f.jpeg";